import React from 'react';

import styles from './versionedName.module.scss';

type VersionedNameProps = {
  name: string;
  version?: number | null;
  isDeprecated?: boolean;
  nameClassName?: string;
  'data-testid'?: string;
};

export function VersionedName( {
  name,
  version,
  isDeprecated,
  nameClassName,
  'data-testid': dataTestId
}: VersionedNameProps ) {
  return (
    <span data-testid={ dataTestId }>
      <span className={ nameClassName }>{ name }</span>
      { version != null && <span className={ styles.muted }> (ver { version })</span> }
      { isDeprecated && <span className={ styles.deprecated_tag }> DEPRECATED</span> }
    </span>
  );
}
